import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export function getUserEnrollments(userId: number) {
  return axios.get(`/api/v2/users/${userId}/sis_enrollments`);
}

export function useGetUserEnrollments(userId: number) {
  return useQuery({
    queryKey: ['users', userId, 'sis_enrollments'],
    queryFn: () => getUserEnrollments(userId).then(response => response.data)
  });
}

export function syncProgress(userId: number, enrollmentId: number) {
  return axios.put(
    `/api/v2/users/${userId}/sis_enrollments/${enrollmentId}/sync_progress`
  );
}

export function transferableSections(
  userId: number,
  enrollmentId: number,
  show_private_sections: boolean
) {
  return axios.get(
    `/api/v2/users/${userId}/sis_enrollments/${enrollmentId}/transferable_sections`,
    {
      params: {
        show_private_sections
      }
    }
  );
}

export function transferEnrollment(
  userId: number,
  enrollmentId: number,
  sisSectionId: number
) {
  return axios.put(
    `/api/v2/users/${userId}/sis_enrollments/${enrollmentId}/transfer`,
    {
      sis_section_id: sisSectionId
    }
  );
}

export function getUnsyncedEnrollments(params = {}) {
  return axios.get('/api/v2/sis_enrollments/unsynced', { params });
}

export function getClassConnectEnrollments(userId: number) {
  return axios.get(`/api/v2/users/${userId}/sis_enrollments/class_connect`);
}

export function useGetClassConnectEnrollments(userId: number) {
  return useQuery({
    queryKey: ['users', userId, 'sis_enrollments', 'class_connect'],
    queryFn: () =>
      getClassConnectEnrollments(userId).then(response => response.data)
  });
}
